export default __webpack_public_path__ + "static/media/UPE_Logo.e16d0b5f.svg";